<h3>Theme</h3>
<mat-slide-toggle [checked]="initialChecked" (change)="toggleTheme($event)">
  Dark theme
</mat-slide-toggle>
